export default [
    {
        "year": 1985,
        "question": "小苏打的分子式是( )",
        "A": "Na2S04.10H20",
        "B": "Na2C03.10H20",
        "C": "NaHCO3",
        "D": "Na2S2O3.5H20",
        "answer": "C"
    },
    {
        "year": 1986,
        "question": "在人类已知的化合物中，品种最多的是（ ）",
        "A": "过渡元素的化合物",
        "B": "第二主族元素的化合物",
        "C": "第三主族元素的化合物",
        "D": "第四主族元素的化合物",
        "answer": "D"
    },
    {
        "year": 1987,
        "question": "在可逆反应X+2Y-2Z-Q中，X、Y、Z是三种气体，Q是热量，为了有利于 Z的生成,应采用的反应条件是（ ）",
        "A": "高温高压",
        "B": "高温低压",
        "C": "常温常压",
        "D": "低温低压",
        "answer": "A"
    },
    {
        "year": 1988,
        "question": "”酸雨”的形成主要是由于（ ）",
        "A": "森林遭到乱砍滥伐，破坏了生态平衡",
        "B": "工业上大量燃烧含硫燃料",
        "C": "大气中二氧化碳的含量增多",
        "D": "汽车排出大量尾气",
        "answer": "B"
    },
    {
        "year": 1989,
        "question": "下列物质中，属于高分子化合物的是（ ）",
        "A": "淀粉",
        "B": "油脂",
        "C": "棉花",
        "D": "蔗糖",
        "answer": "A"
    },
    {
        "year": 1990,
        "question": "通常用来衡量一个国家的石油化学工业发展水平的标志是（ ）",
        "A": "石油的产量",
        "B": "乙烯的产量",
        "C": "合成纤维的产量",
        "D": "硫酸的产量",
        "answer": "B"
    },
    {
        "year": 1991,
        "question": "设某元素某原子核内的质子数为m，中子数为n，则下述论断正确的是（ ）",
        "A": "不能由此确定该元素的原子量",
        "B": "这种元素的原子量为m+n",
        "C": "若碳原子质量为W克，此原子的质量为(m+n)W克",
        "D": "核内中子的总质量小于质子的总质量",
        "answer": "A"
    },
    {
        "year": 1992,
        "question": "在炼铁、制玻璃、制水泥三种工业生产中，都需要的原料是（ ）",
        "A": "纯碱",
        "B": "石灰石",
        "C": "石英",
        "D": "粘土",
        "answer": "B"
    },
    {
        "year": 1993,
        "question": "下列元素的单质中，最易跟氢气反应生成氢化物的是（ ）",
        "A": "硼",
        "B": "氮",
        "C": "氟",
        "D": "碳",
        "answer": "C"
    },
    {
        "year": 1994,
        "question": "下列气体不会造成大气污染的是（ ）",
        "A": "二氧化硫",
        "B": "氦气",
        "C": "一氧化碳",
        "D": "一氧化氮",
        "answer": "B"
    },
    {
        "year": 1995,
        "question": "N和Ne的原子半径（ ）",
        "A": "大于",
        "B": "小于",
        "C": "等于",
        "D": "不能肯定",
        "answer": "B"
    },
    {
        "year": 1996,
        "question": "原子核外的M电子层和L电子层最多可容纳的电子数（ ）",
        "A": "大于",
        "B": "小于",
        "C": "等于",
        "D": "不能肯定",
        "answer": "A"
    },
    {
        "year": 1997,
        "question": "19世纪中叶，门捷列夫的突出贡献是( )",
        "A": "提出原子学说",
        "B": "发现元素周期律",
        "C": "提出分子学说",
        "D": "发现氧气",
        "answer": "B"
    },
    {
        "year": 1998,
        "question": "起固定氮作用的化学反应是（ ）",
        "A": "氮气与氢气在一定条件下反应生成氨气",
        "B": "一氧化氮与氧气反应生成二氧化氮",
        "C": "氨气经催化氧化生成一氧化氮",
        "D": "由氨气制碳酸氢铵和硫酸铵",
        "answer": "A"
    },
    {
        "year": 1999,
        "question": "近年来，我国许多城市禁止汽车使用含铅汽油，其主要原因是（ ）",
        "A": "提高汽油燃烧效率",
        "B": "降低汽油成本",
        "C": "避免铅污染大气",
        "D": "铅资源短缺",
        "answer": "C"
    },
    {
        "year": 2000,
        "question": "导致下列现象的主要原因与排放SO2有关的是（ ）",
        "A": "酸雨",
        "B": "光化学烟雾",
        "C": "臭氧空洞",
        "D": "温室效应",
        "answer": "A"
    },
    {
        "year": 2001,
        "question": "为了保护臭氧层，可采取的有效措施是（  ）",
        "A": "减少二氧化硫的排放量",
        "B": "减少含铅废气的排放量",
        "C": "减少氟氯代烃的排放量",
        "D": "减少二氧化碳的排放量",
        "answer": "C"
    },
    {
        "year": 2002,
        "question": "以下说法正确的是（ )",
        "A": "纳米材料是指一种称为“纳米”的新物质制成的材料",
        "B": "绿色食品是指不含任何化学物质的食品",
        "C": "生物固氮是指植物通过叶面直接吸收空气中的氮气",
        "D": "光导纤维是以二氧化硅为主要材料制成的",
        "answer": "D"
    },
    {
        "year": 2003,
        "question": "通常用来衡量一个国家的石油化学工业发展水平的标志是（ ）",
        "A": "石油的产量",
        "B": "乙烯的产量",
        "C": "合成纤维的产量",
        "D": "硫酸的产量",
        "answer": "B"
    },
    {
        "year": 2004,
        "question": "下列分子含有的电子数目与HF相同，且只有两个极性共价键的是( )",
        "A": "CO2",
        "B": "N2O",
        "C": "HzO",
        "D": "CH4",
        "answer": "C"
    },
    {
        "year": 2005,
        "question": "下列分子中所有原子都满足最外层为8电子结构的是（ ）",
        "A": "ABF3",
        "B": "H2O",
        "C": "SiC4",
        "D": "PCl5",
        "answer": "C"
    },
    {
        "year": 2006,
        "question": "在常温常压下呈气态的化合物、降温使其固化得到的晶体属于( )",
        "A": "分子晶体",
        "B": "原子晶体",
        "C": "离子晶体",
        "D": "何种晶体无法判断",
        "answer": "A"
    },
    {
        "year": 2007,
        "question": "下列有关环境问题的说法正确的是（ ）",
        "A": "燃煤时加入适量石灰石，可减少废气中SQ的量",
        "B": "臭氧的体积分数超过10%的空气有利于人体健康",
        "C": "pH在5.6～7.0之间的降水通常称为酸雨",
        "D": "以上说法均不正确",
        "answer": "A"
    },
    {
        "year": 2008,
        "question": "下列各组物质不属于同分异构体的是（ ）",
        "A": "2，2-二甲基丙醇和2-甲基丁醇",
        "B": "邻氯甲苯和对氯甲苯",
        "C": "2-甲基丁烷和戊烷",
        "D": "甲基丙烯酸和甲酸丙酯",
        "answer": "D"
    },
    {
        "year": 2009,
        "question": "除去NaHCO3溶液中混有的少量Na2CO3可采取的方法是：",
        "A": "通入二氧化碳气体",
        "B": "加入氢氧化钡溶液",
        "C": "加入澄清石灰水",
        "D": "加入稀盐酸",
        "answer": "A"
    },
    {
        "year": 2010,
        "question": "下面关于SiOz晶体网状结构的叙述正确的是（ ）",
        "A": "存在四面体结构单元，O处于中心，Si处于4个顶角",
        "B": "最小的环上，有3个Si原子和3个O原子",
        "C": "最小的环上，Si和O原子数之比为1:2",
        "D": "最小的环上，有6个Si原子和6个O原子",
        "answer": "D"
    },
    {
        "year": 2011,
        "question": "下列叙述错误的是（ ）",
        "A": "用金属钠可区分乙醇和乙谜",
        "B": "用高锰酸钾酸性溶液可区分己烷和3-己烯",
        "C": "用水可区分苯和澳苯",
        "D": "用新制的银氨溶液可区分甲酸甲酯和乙醛",
        "answer": "D"
    },
    {
        "year": 2012,
        "question": "下列说法中正确的是（ ）",
        "A": "医用酒精的浓度通常为95%",
        "B": "单质硅是将太阳能转变为电能的常用材料",
        "C": "淀粉、纤维素和油脂都属于天然高分子化合物",
        "D": "合成纤维和光导纤维都是新型无机非金属材料",
        "answer": "B"
    },
    {
        "year": 2013,
        "question": "下面有关发泡塑料饭盒的叙述，不正确的是（ ）",
        "A": "主要材质是高分子材料",
        "B": "价廉、质轻、保温性能好",
        "C": "适用于微波炉加热食品",
        "D": "不适于盛放含油较多的食品",
        "answer": "C"
    },
    {
        "year": 2014,
        "question": "下列过程没有发生化学反应的是（ ）",
        "A": "用活性炭去除冰箱中的异味",
        "B": "用热碱水清除炊具上残留的油污",
        "C": "用浸泡过高锰酸钾溶液的硅藻土保鲜水果",
        "D": "用含硅胶、铁粉的透气小袋与食品一起密封包装",
        "answer": "A"
    },
    {
        "year": 2015,
        "question": "化学与生活密切相关．下列应用中利用了物质氧化性的是（  ）",
        "A": "明矾净化水",
        "B": "纯碱去油污",
        "C": "食醋除水垢",
        "D": "漂白粉漂白织物",
        "answer": "D"
    },
    {
        "year": 2016,
        "question": "化学与生活密切相关。下列有关说法错误的是（ ）",
        "A": "用灼烧的方法可以区分蚕丝和人造纤维",
        "B": "食用油反复加热会产生稠环芳泾等有害物质",
        "C": "加热能杀死流感病毒是因为蛋白质受热变性",
        "D": "医用消毒酒精中乙醇的浓度为95%",
        "answer": "D"
    },
    {
        "year": 2017,
        "question": "化学与生活密切相关。下列说法错误的是（ ）",
        "A": "PM2.5是指粒径不大于2.5μm的可吸入悬浮颗粒物",
        "B": "绿色化学要求从源头上消除或减少生产活动对环境的污染",
        "C": "燃煤中加入CaO可以减少酸雨的形成及温室气体的排放",
        "D": "天然气和液化石油气是我国目前推广使用的清洁燃料",
        "answer": "C"
    },
    {
        "year": 2018,
        "question": "化学与生活密切相关。下列说法错误的是（ ）",
        "A": "泡沫灭火器可用于一般的起火，也适用于电器起火",
        "B": "疫苗一般应冷藏存放，以避免蛋白质变性",
        "C": "家庭装修时用水性漆替代传统的油性漆，有利于健康及环境",
        "D": "电热水器用镁棒防止内胆腐蚀，原理是牺牲阳极的阴极保护法",
        "answer": "A"
    },
    {
        "year": 2019,
        "question": "下列属于碱的是（）",
        "A": "C2H5OH",
        "B": "Na2CO3",
        "C": "Ca(OH)2",
        "D": "Cu2(OH)2CO3",
        "answer": "C"
    },
    {
        "year": 2020,
        "question": "下列广告用语在科学性上没有错误的是（ ）",
        "A": "这种饮料中不含任何化学物质",
        "B": "这种蒸馏水绝对纯净，其中不含任何离子",
        "C": "这种口服液含丰富的氮、磷、锌等微量元素",
        "D": "没有水就没有生命",
        "answer": "B"
    }
]